/* OVANEA | ovcm (16/10/2026) : prix du bouton d'ajout = prix de la variante x quantité affichée.
   Le thème remplace le bouton (et le sélecteur de quantité) à chaque changement de variante, mais continue de lire l'ancien champ
   de quantité : après un changement de coloris, le bouton gardait l'ancienne quantité et « + » ne le mettait plus à jour.
   1) le calcul lit toujours le champ de quantité présent dans la page ; 2) un changement de quantité relance le calcul. */
(function () {
  function courant(pf) {
    var c = pf.querySelector('[data-ref="product-quantity-selector"] input[name="quantity"]');
    if (c) pf.quantitySelectorInput = c;
  }
  customElements.whenDefined('product-form').then(function () {
    var P = customElements.get('product-form').prototype, g = P.getCurrentTotalPrice;
    if (typeof g !== 'function' || g.ovcm) return;
    P.getCurrentTotalPrice = function () { courant(this); return g.apply(this, arguments); };
    P.getCurrentTotalPrice.ovcm = true;
  });
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || i.name !== 'quantity') return;
    var pf = i.closest && i.closest('product-form');
    if (!pf || typeof pf.onFormUpdated !== 'function') return;
    setTimeout(function () { courant(pf); pf.onFormUpdated(); }, 0);
  }, true);
})();
